import { layouts, common } from '@ocean/ui'
import { LogoWrapper, TitleWrapper, Content } from './MarketingMode.styled'
import logos from './assets/logos.png'

const { Decorator, Typography } = common
const { PageLayout, PageSegment, SectionLayout, SectionSpaceLayout, SectionSpaceSize } = layouts

type MarketingModeProps = {
  customerName: Nullable<string>
}

const MarketingMode: React.FC<MarketingModeProps> = ({ customerName }) => {
  const supportEmail = 'support@oceantg.com'
  const customerSubjectPrefix = customerName ? `(${customerName}) ` : ''

  return (
    <PageLayout>
      <PageSegment segmentId='content'>
        <Decorator root backgroundColor='white' textColor='black'>
          <SectionSpaceLayout size={SectionSpaceSize.Large}>
            <SectionLayout>
              <LogoWrapper>
                <img src={logos} alt='Ocean and Wärtsilä logos' />
              </LogoWrapper>
              <TitleWrapper>
                <Typography variant='h2'>
                  You're just a step away from accessing simulation in your Ocean Learning Platform.
                </Typography>
              </TitleWrapper>
              <Content>
                <Typography variant='p'>
                  You can now utilise the full range of Wärtsilä Cloud Simulators from your OLP
                  account, enabling you to use the simulation for mission planning, training,
                  pre-employment assessment, and whatever else you can dream of.
                </Typography>
                <Typography variant='p'>
                  Cloud Simulation access has been added to your account at no additional cost, and
                  Wärtsilä is providing you with 25 hours of simulator access completely free of
                  charge.
                </Typography>
                <Typography variant='p'>
                  <b>What next?</b>
                </Typography>
                <Typography variant='p'>
                  To access your free hours please send us an email at{' '}
                  <a
                    href={`mailto:${supportEmail}?subject=${customerSubjectPrefix}Wärtsilä Cloud Simulation activation`}
                  >
                    <b>{supportEmail}</b>
                  </a>{' '}
                  and nominate a user on your account to administer simulator sessions. Please add
                  'Wärtsilä Cloud Simulation activation' to the email subject line.
                </Typography>
                <Typography variant='p'>
                  We will then arrange personal onboarding sessions, including video tutorials, to
                  ensure you have everything you need to get the most from Cloud Simulation.
                </Typography>
                <Typography variant='p'>
                  Thank you for your interest in Wärtsilä Cloud Simulation, and we look forward to
                  giving you a tour of this great new functionality!
                </Typography>
              </Content>
            </SectionLayout>
          </SectionSpaceLayout>
        </Decorator>
      </PageSegment>
    </PageLayout>
  )
}

export default MarketingMode
